import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AppInsightsService } from '../app-insights.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as signalR from '@microsoft/signalr';
import { UserSessionService } from '../../services/usersession.service';
import { Subject } from 'rxjs';
import {
    IGetNotificationCount, IGetNotificationFollowUps, IGetNotificationScheduledMove, IGetNotificationUnitsLocked, IRemoveNotification,
    IRemoveResponse, IFileExport, IGetNotificationInventoryReorder, IGetNotificationAutoCCDeclineCountList, IGetNotificationAutoCCDeclineDetail, IGetNotificationTasks, IGetNotificationAuctionEligibleSubCategory, IAuctionEligibleUnitDetailsModel, IGetNotificationApprovalCount, IApprovalsDetailsModel, IFacilityApprovalCount, IFacilityBatchApprovalCount, IBatchApprovalUnits
} from '../../Shared/models/notification-model';
import { AppService } from '../app.service';
import { INotificationSettings } from 'src/app/Shared/interface';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private baseURL = this.appService.config.apiBaseUrl;
    private notificationCountSubject = new Subject<{ facilityId: number, model: any}>();
   private notificationToaster = new Subject<{ popupData: any;facilityId:number; userId?: number;usergroupId?:number,facilitylist?:any }>();
    public notificationToaster$ = this.notificationToaster.asObservable();
    public notificationCount$ = this.notificationCountSubject.asObservable();
    private currentFacilityId: number | null = null;
    public previousNotificationCountObj ;
    private notificationHubConnection: signalR.HubConnection;
    private popupHubConnection: signalR.HubConnection;
    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    userID=this.userSessionService?.userSessionData?.UserId;
    constructor(private http: HttpClient,
        private appinsights: AppInsightsService,
        private userSessionService: UserSessionService,
        private appService: AppService) { }

    getNotificationCount(facilityId): Observable<IGetNotificationCount[]> {
        return this.http.get<IGetNotificationCount[]>(
            `${this.baseURL}/Notification/GetNotificationCount?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationCount[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationFollowUps(facilityId, pageCount, pageSize): Observable<IGetNotificationFollowUps[]> {
        return this.http.get<IGetNotificationFollowUps[]>(
            `${this.baseURL}/Notification/GetNotificationFollowUps?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationFollowUps[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationTasks(facilityId): Observable<IGetNotificationTasks[]> {
        return this.http.get<IGetNotificationTasks[]>(`${this.baseURL}/Notification/GetLookUpTaskDetails?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationTasks[];
                }),
                catchError(this.handleError)
            );
    }

    UpdateLookUpTask(taskId: number): Observable<IRemoveResponse> {
        const url = `${this.baseURL}/Notification/UpdateLookUpTask?taskId=${taskId}`;
        return this.http.post<IRemoveResponse>(url, this.options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getNotificationScheduledMoveIns(facilityId, pageCount, pageSize): Observable<IGetNotificationScheduledMove[]> {
        return this.http.get<IGetNotificationScheduledMove[]>(
            `${this.baseURL}/Notification/GetNotificationScheduledMoveIns?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationScheduledMove[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationScheduledMoveOut(facilityId, pageCount, pageSize): Observable<IGetNotificationScheduledMove[]> {
        return this.http.get<IGetNotificationScheduledMove[]>(
            `${this.baseURL}/Notification/GetNotificationScheduledMoveOuts?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationScheduledMove[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationUnitsLocked(facilityId, pageCount, pageSize): Observable<IGetNotificationUnitsLocked[]> {
        return this.http.get<IGetNotificationUnitsLocked[]>(
            `${this.baseURL}/Notification/GetNotificationUnitsToBeLocked?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationUnitsLocked[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationUnitsUnLocked(facilityId, pageCount, pageSize): Observable<IGetNotificationUnitsLocked[]> {
        return this.http.get<IGetNotificationUnitsLocked[]>(
            `${this.baseURL}/Notification/GetNotificationUnitsToBeUnLocked?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationUnitsLocked[];
                }),
                catchError(this.handleError)
            );
    }

    GetApprovalCount(): Observable<IGetNotificationApprovalCount> {
        return this.http.get<IGetNotificationApprovalCount>(
            `${this.baseURL}/Notification/GetApprovalCount`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationApprovalCount;
                }),
                catchError(this.handleError)
            );
    }

    GetApprovalDetails(facilityId: number, approvalType: number): Observable<IApprovalsDetailsModel[]> {
        return this.http.get<IApprovalsDetailsModel[]>(
            `${this.baseURL}/Notification/GetApprovalDetails?facilityId=${facilityId}&approvalType=${approvalType}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IApprovalsDetailsModel[];
                }),
                catchError(this.handleError)
            );
    }

    GetFacilityApprovalCounts(approvalType: number): Observable<IFacilityApprovalCount[]> {
        return this.http.get<IFacilityApprovalCount[]>(
            `${this.baseURL}/Notification/GetFacilityApprovalCounts?approvalType=${approvalType}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IFacilityApprovalCount[];
                }),
                catchError(this.handleError)
            );
    }

    DMorRMApprovalForRefundandReversal(input): Observable<IRemoveResponse> {
        const url = `${this.baseURL}/Notification/DMorRMApprovalForRefundandReversal`;
        return this.http.post<IRemoveResponse>(url, input, this.options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    GetAuctionEligibleSubCategoryCount(facilityId: number): Observable<IGetNotificationAuctionEligibleSubCategory> {
        return this.http.get<IGetNotificationAuctionEligibleSubCategory>(
            `${this.baseURL}/Notification/GetAuctionEligibleCount?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationAuctionEligibleSubCategory;
                }),
                catchError(this.handleError)
            );
    }
    GetFacilityAuctionEligibleUnitsCount(): Observable<IFacilityApprovalCount[]> {
        return this.http.get<IFacilityApprovalCount[]>(
            `${this.baseURL}/Notification/GetFacilityAuctionEligibleUnitsCount`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IFacilityApprovalCount[];
                }),
                catchError(this.handleError)
            );
    }

    GetAuctionEligibleUnits(facilityId: number, auctionType: number): Observable<IAuctionEligibleUnitDetailsModel[]> {
        return this.http.get<IAuctionEligibleUnitDetailsModel[]>(
            `${this.baseURL}/Notification/GetAuctionEligibleUnits?facilityId=${facilityId}&auctionType=${auctionType}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IAuctionEligibleUnitDetailsModel[];
                }),
                catchError(this.handleError)
            );
    }

    UpdateNotificationAuctionUnit(leaseNo, facilityId, approvalStatus): Observable<IRemoveResponse> {
        const url =
            `${this.baseURL}/Notification/UpdateAuctionUnit?leaseNo=${leaseNo}&facilityId=${facilityId}&approvalStatus=${approvalStatus}`;
        return this.http.post<IRemoveResponse>(url, this.options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getNotificationAutoCCDeclineCountList(facilityId): Observable<IGetNotificationAutoCCDeclineCountList[]> {
        return this.http.get<IGetNotificationAutoCCDeclineCountList[]>(
            `${this.baseURL}/Notification/GetAutoCCDeclineCountList?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationAutoCCDeclineCountList[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationAutoCCDeclineCountDetail(leaseNo, facilityId, dateTime): Observable<IGetNotificationAutoCCDeclineDetail[]> {
        return this.http.get<IGetNotificationAutoCCDeclineDetail[]>(
            `${this.baseURL}/Notification/GetAutoCCDeclineDetails?leaseNo=${leaseNo}&facilityId=${facilityId}&dateTime=${dateTime}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationAutoCCDeclineDetail[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationInventoryReorder(facilityId): Observable<IGetNotificationInventoryReorder[]> {
        return this.http.get<IGetNotificationInventoryReorder[]>(
            `${this.baseURL}/Notification/GetInventoryReOrderList?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationInventoryReorder[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationOnRentals(facilityId, pageCount, pageSize): Observable<IGetNotificationUnitsLocked[]> {
        return this.http.get<IGetNotificationUnitsLocked[]>(
            `${this.baseURL}/Notification/GetNotificationOnlineRentals?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationUnitsLocked[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationOnlinePayments(facilityId, pageCount, pageSize): Observable<IGetNotificationUnitsLocked[]> {
        return this.http.get<IGetNotificationUnitsLocked[]>(
            `${this.baseURL}/Notification/GetNotificationOnlinePayments?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationUnitsLocked[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationOnlineReservation(facilityId, pageCount, pageSize): Observable<IGetNotificationUnitsLocked[]> {
        return this.http.get<IGetNotificationUnitsLocked[]>(
            `${this.baseURL}/Notification/GetNotificationOnlineReservations?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationUnitsLocked[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationOnlineInquiries(facilityId, pageCount, pageSize): Observable<IGetNotificationUnitsLocked[]> {
        return this.http.get<IGetNotificationUnitsLocked[]>(
            `${this.baseURL}/Notification/GetNotificationOnlineInquiries?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationUnitsLocked[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationCallCenterAlerts(facilityId, pageCount, pageSize): Observable<IGetNotificationUnitsLocked[]> {
        return this.http.get<IGetNotificationUnitsLocked[]>(
            `${this.baseURL}/Notification/GetNotificationCallCenterAlerts?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationUnitsLocked[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationDayEndTenantLettersAndNotices(facilityId, dayEndType, letterDate, pageCount, pageSize): Observable<IGetNotificationUnitsLocked[]> {
        return this.http.get<IGetNotificationUnitsLocked[]>(
            `${this.baseURL}/Notification/GetNotificationDayEndTenantLettersAndNotices?facilityId=${facilityId}&dayEndType=${dayEndType}&tDate=${letterDate}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationUnitsLocked[];
                }),
                catchError(this.handleError)
            );
    }

    getNotificationDayEndTenantLettersAndNoticesByDate(facilityId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Notification/GetNotificationDayEndTenantLettersAndNoticesByDate?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    getNotificationDayEndReportsByDate(facilityId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Notification/GetNotificationDayEndReportsByDate?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    getNotificationRentRaiseAlt(facilityId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Notification/GetRentRaiseBatchCount?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    UpdateRentRaiseBatch(rentRaiseId): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this.http.post<boolean>(`${this.baseURL}/Notification/UpdateRentRaiseBatch?rentRaiseBatchId=${rentRaiseId}`, options);
    }

    getNotificationDayEndReports(facilityId, reportDate, pageCount, pageSize): Observable<IGetNotificationUnitsLocked[]> {
        return this.http.get<IGetNotificationUnitsLocked[]>(
            `${this.baseURL}/Notification/GetNotificationDayEndReports?facilityId=${facilityId}&tDate=${reportDate}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IGetNotificationUnitsLocked[];
                }),
                catchError(this.handleError)
            );
    }

    removeNotification(obj: IRemoveNotification): Observable<IRemoveResponse> {
        const url = `${this.baseURL}/Notification/RemoveNotification`;
        return this.http.post<IRemoveResponse>(url, obj, this.options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    removeNotificationAutoCreditCardDecline(leaseNo, facilityId, dateTime): Observable<IRemoveResponse> {
        const url = `${this.baseURL}/Notification/UpdateAutoCCDecline?leaseNo=${leaseNo}&facilityId=${facilityId}&dateTime=${dateTime}`;
        return this.http.post<IRemoveResponse>(url, this.options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getNotificationFileExport(facilityId, pageCount, pageSize): Observable<IFileExport[]> {
        return this.http.get<IFileExport[]>(
            `${this.baseURL}/Notification/GetNotificationFileExports?facilityId=${facilityId}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IFileExport[];
                }),
                catchError(this.handleError)
            );
    }

    removeFileExportNotification(FileExpId,facilityId?): Observable<IRemoveResponse> {
        const url = `${this.baseURL}/Notification/RemoveFileExportNotification?fileExportId=${FileExpId}&facilityId=${facilityId}`;
        return this.http.post<IRemoveResponse>(url, FileExpId, this.options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    GetNotificationMailhouseErrorByDate(facilityId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Notification/GetNotificationMailhouseErrorByDate?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    GetNotificationMailhouseDetails(facilityId, tDate, pageCount, pageSize): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Notification/GetNotificationMailhouseDetails?facilityId=${facilityId}&tDate=${tDate}&pageCount=${pageCount}&pageSize=${pageSize}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    GetScheduledReportNotification(facilityId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Notification/GetScheduledReportNotification?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    GetNotificationSettings(userID: number): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Notification/GetNotificationSettings?userID=${userID}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const listdata = res.body as any;
                    return listdata;
                }),
                catchError(this.handleError)
            );
    }

    GetExpiredProofOfPPNotification(facilityId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Notification/GetNotificationExpiredInsurance?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    GetRemovedFromAuctionNotification(facilityId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Notification/GetUnitsRemovedfromAuction?facilityId=${facilityId}`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    
    getNotificationSettingsByUser(): Observable<INotificationSettings[]> {
        return this.http.get<INotificationSettings[]>(
          `${this.baseURL}/NotificationSettings/GetNotificationSettingsByUser`,
          { observe: 'response' })
          .pipe(
            map(res => {
              const notificationSettings = res.body as INotificationSettings[];
              return notificationSettings;
            }),
            catchError(this.handleError)
          );
      }

      GetPendingRemotePayment(facilityId): Observable<any>{
        return this.http.get<any>(
            `${this.baseURL}/Notification/GetPendingRemotePayments?facilityId=${facilityId}`,
            { observe: 'response' })
            .pipe(
              map(res => {
                const notificationSettings = res.body as any;
                return notificationSettings;
              }),
              catchError(this.handleError)
            );
      }

      GetUserFacilityIds(groupId):Observable<any>{
        return this.http.get<any>(
            `${this.baseURL}/Usergroups/GetUserGroupDetailsForOp?groupId=${groupId}`,
            { observe: 'response' })
            .pipe(
              map(res => {
                const notificationSettings = res.body as any;
                return notificationSettings;
              }),
              catchError(this.handleError)
            );
      }

    GetDeclinedACHPayments(facilityId): Observable<any>{
    return this.http.get<any>(
        `${this.baseURL}/Notification/GetDeclinedACHPayments?facilityId=${facilityId}`,
        { observe: 'response' })
        .pipe(
            map(res => {
            const notificationSettings = res.body as any;
            return notificationSettings;
            }),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

    public startConnection(baseUrl: string, facilityId: number): void {
        this.currentFacilityId=facilityId;
        this.notificationHubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${baseUrl.replace('/api', '/') + 'NotificationHub'}?facilityId=${facilityId}`)
            .withAutomaticReconnect()
            .build();

        this.notificationHubConnection
            .start()
            .then(() => {
                console.log('Connected to NotificationHub');
                this.addNotificationListener();
                this.addPopupListener();
                this.receiveAlertMessage();
                setTimeout(() => {
                     this.getNotificationUpdate(facilityId);
                }, 2000);
               
            })
            .catch(err => console.error('NotificationHub connection error:', err));
    }
    
    private addNotificationListener(): void {
        this.notificationHubConnection.on('ReceiveNotificationCount', (facilityId: number, model: any) => {
            console.log('Received notification:', model);
            this.notificationCountSubject.next({ facilityId, model });
        });
    }
      private receiveAlertMessage(): void {
        this.notificationHubConnection.off('ReceiveNotificationAlert');
        this.notificationHubConnection.on('ReceiveNotificationAlert', (facilityId: number, userId: any,usergroupId: any) => {
          console.log('receiveAlertMessage', userId,usergroupId);

          this.getNotificationUpdate(facilityId,userId,usergroupId);
        });
      }
    private addPopupListener(): void {
        var facilitylist
        this.notificationHubConnection.on('ReceiveToaster', (...args: any[]) => {
            try {
                console.log('ReceiveToaster called with args:', args);
                const [popupData,facilityId, userId, usergroupId] = args;
                if (usergroupId != null) {
                    this.GetUserFacilityIds(usergroupId).subscribe((response: any) => {
                        facilitylist = response.UserList;

                        this.notificationToaster.next({ popupData,facilityId, userId, usergroupId,  facilitylist});
                    })
                }else{
                     this.notificationToaster.next({ popupData,facilityId, userId, usergroupId});
                }
            } catch (err) {
                console.error('Error in ReceiveToaster handler:', err);
            }
        });
    }
      public stopConnection(): void {
        this.notificationHubConnection?.stop().then(() => console.log('SignalR stopped'));
        this.notificationHubConnection = undefined!;
      }
      isConnectedTo(newfacilityId: number): boolean {
        return (
          this.currentFacilityId === newfacilityId 
        );
    }

    private getNotificationUpdate(facilityId, userId?, usergroupId?): void {
        var facilityUSerList;
        if (this.notificationHubConnection?.state === signalR.HubConnectionState.Connected, (facilityId == this.currentFacilityId || this.currentFacilityId == 0)) {
            if (usergroupId != null) {
                this.GetUserFacilityIds(usergroupId).subscribe((response: any) => {
                    facilityUSerList = response.UserList;
                    if (facilityUSerList?.some((user: any) => user.Id === this.userSessionService.userSessionData.UserId)) {
                        this.notificationHubConnection.invoke('UpdateNotificationCount', this.currentFacilityId, this.userID)
                            .then(() => {
                                console.log('Popup NotifyUpdate invoked');
                            })
                            .catch(err => console.error('NotifyUpdate failed:', err));
                    }
                })
            } else if (userId != null) {
                if (userId == this.userID) {
                    this.notificationHubConnection.invoke('UpdateNotificationCount', this.currentFacilityId, this.userID)
                        .then(() => {
                            console.log('Popup NotifyUpdate invoked');
                        })
                        .catch(err => console.error('NotifyUpdate failed:', err));
                }
            }
            else {
                this.notificationHubConnection.invoke('UpdateNotificationCount', this.currentFacilityId, this.userID)
                    .then(() => {
                        console.log('Popup NotifyUpdate invoked');
                    })
                    .catch(err => console.error('NotifyUpdate failed:', err));
            }

        }
    }

    GetBatchApprovalFacilities(): Observable<IFacilityBatchApprovalCount[]> {
        return this.http.get<IFacilityBatchApprovalCount[]>(
            `${this.baseURL}/Notification/GetBatchApprovalFacilities`,
            { observe: 'response' }).pipe(
                map(res => {
                    return res.body as IFacilityBatchApprovalCount[];
                }),
                catchError(this.handleError)
            );
    }

    GetBatchApprovalUnits(input): Observable<IBatchApprovalUnits[]> {
        const url = `${this.baseURL}/Notification/GetBatchApprovalUnits`;
        return this.http.post<IBatchApprovalUnits[]>(url, input, this.options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );

    }

}
